type ActionBannerProps = {
  text: string;
  onClick?: () => void;
  className?: string;
};

export const ActionBanner = ({ text, onClick, className }: ActionBannerProps) => (
  <div className={`pb-6 ${className ?? ""}`}>
    <button
      type="button"
      onClick={onClick}
      className="text-attention-darkest mt-2 p-3 pl-6 pr-8 rounded-xl bg-neutral-white w-60% border border-primary-medium transition hover:bg-primary-lightest focus:outline-none focus:ring-2 focus:ring-primary-medium cursor-pointer text-left font-semibold shadow"
      style={{ display: "block" }}
    >
      {text}
    </button>
  </div>
);
